// Get the domain ignoring the port to work locally
const getDomain = (host = '') => {
	if (host) {
		const match = host.match(/\.(.*?)(:|\/|$)/);
		return match ? match[1] : '';
	}
	return host;
};

// Validate the domain of a redirect to
const ensureDomainSafeLink = (redirectTo: string | null, current: Location) => {
	if (redirectTo) {
		if (redirectTo.startsWith('/') && !redirectTo.startsWith('//')) {
			//always safe if it's a link relative to the domain
			return redirectTo;
		}

		try {
			const newUrl = new URL(redirectTo);
			// Remove the subdomain from each host string to get main domain to compare.
			const newDomain = getDomain(newUrl.host);
			const currentDomain = getDomain(current.host);

			if (newDomain === currentDomain) {
				return redirectTo;
			}
		} catch {
			return null;
		}
		return null;
	}

	return redirectTo;
};

export { ensureDomainSafeLink };
